import { Component, HelperFunctions, } from "../../tsthree";
import { LoadingScreenSystem } from "../Systems/LoadingScreenSystem";
import { BaseTexture, Container, Graphics, NineSlicePlane, Sprite, Text, TextStyle, Texture } from "pixi.js";
import { tsthreeConfig } from "../../config/tsthreeConfig";
import { randElem } from "../../engine/HelperFunctions/randElem";

const loadingMessages = [
    "Sterilizing instruments",
    "Practicing sutures",
    "Ordering lab tests",
    "Refilling the crash cart",
    "Sanitizing hands",
    "Updating patient records",
    "Checking vital signs",
    "Scrubbing in",
    "Studying medical journals",
    "Reading EKGs",
    "Running diagnostics",
    "Consulting with specialists",
    "Double checking dosages",
    "Preparing operating room",
    "Brewing coffee for the night shift",
    "Mixing antiseptic",
    "Calibrating defibrillator",
    "Reviewing anatomy textbook",
    "Administering mild sedative",
    "Activating the MRI machine",
    "Restocking medical supplies",
    "Analyzing patient history",
    "Tuning stethoscope",
    "Calming nervous patients",
    "Calling a code blue",
    "Preparing for rounds",
    "Donning surgical gloves",
    "Consulting the Hippocratic Oath",
    "Warming up the ultrasound",
    "Practicing medical ethics",
    "Dusting off the caduceus",
    "Reticulating spines",
];

export class LoadingScreenComponent extends Component {
    public static readonly id: string = "LoadingScreenComponent";
    protected static readonly _system: typeof LoadingScreenSystem = LoadingScreenSystem;

    public _texture: Texture;
    public _progressTexture: Texture;
    public _progressBgTexture: Texture;
    private _progress: number = 0;
    private _nineSlice: NineSlicePlane;
    private _progressBarMask: Graphics;
    private _progressBarBg: NineSlicePlane;
    private _text: Text;

    constructor() {
        super();
    }

    public get progress(): number {
        return this._progress;
    }

    public set progress(_val: number) {
        this._progress = _val;

        if(this._text) {
            this._text.text = randElem(loadingMessages) + "...";
        }

        if(this._progressBarMask && this._progressBarBg) {
            this._progressBarMask.width = (
                this._progressBarBg.width * (this._progress / 100)
            );
        }

        // @ts-ignore
        this.parent.render(ENGINE.getUIManager().getRenderer());
    }

    onAttach(): void {
        // create texture here
        const _baseTexture = new BaseTexture(
            `data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAIAAACQkWg2AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAOUlEQVQokWO8f+M+A9FAUUORhYGBQUFBgRjVDQ0NDAwMLBDOgQMHiLSEiXj3jGoYWRpYGGCpilYAAPdWCMTpdHy+AAAAAElFTkSuQmCC`
        );
        const _baseTextureProgress = new BaseTexture(
            `data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAALMAAAANCAYAAADi1F/2AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAYklEQVRoge3ZsQmAQAyG0Yu4kc7kUM6kM8XK0k5Qft6rDtKk+Ehz1d0DEkxfLwBvme9H1f54oo9jqXU9zc1/Oe/eagyXmSBiJoaYiSFmYoiZGGImhpiJIWZilO9sUrjMxLgAao9eFbmP3JAAAAAASUVORK5CYII=`
        );
        const _baseTextureBg = new BaseTexture(
            `data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAIAAACQkWg2AAAACXBIWXMAAAsTAAALEwEAmpwYAAAALElEQVQokWNsaGhgIBrU19ezMDAwODg4EK+HiXiloxpGNVBXA+P///9J0gAAyBIG24InmjoAAAAASUVORK5CYII=`
        );
        this._texture = new Texture(_baseTexture);
        this._progressTexture = new Texture(_baseTextureProgress);
        this._progressBgTexture = new Texture(_baseTextureBg);

        HelperFunctions.waitForTruth(
            () => (
                (_baseTexture.valid && this._texture.valid) &&
                (_baseTextureProgress.valid && this._progressTexture.valid) &&
                (_baseTextureBg.valid && this._progressBgTexture.valid)
            )
        ).then(() => {
            // ready to use
            const test = this._nineSlice = new NineSlicePlane(this._texture);
            test.width = 220;
            test.height = 80;
            test.position.set(
                Math.floor(-110 + (tsthreeConfig.width * 0.5)),
                Math.floor(tsthreeConfig.height * 0.5),
            );
            this.parent.addChild(test);

            const text = this._text = new Text(randElem(loadingMessages), new TextStyle({
                fontFamily: "Courier New",
                fontSize: 11,
                fill: 0x0a0a0a,
                align: "center",
                wordWrap: true,
                wordWrapWidth: test.width - 4
            }));
            text.anchor.set(0.5, 0.5);
            text.position.set(
                Math.floor(test.width * 0.5),
                22
            );
            test.addChild(text);

            const progressBarBg = this._progressBarBg = new NineSlicePlane(
                this._progressBgTexture
            );
            progressBarBg.position.set(
                Math.round(-(this._progressTexture.width * 0.5) + (test.width * 0.5)),
                48
            );
            test.addChild(progressBarBg);

            const progressBarContainer = new Container();
            progressBarContainer.position.set(0, 1);
            const progressBar = new Sprite(
                this._progressTexture
            );
            progressBarBg.width = progressBar.width + 1;
            progressBarBg.addChild(progressBarContainer);
            progressBarContainer.addChild(progressBar);
            const progressBarMask = this._progressBarMask = new Graphics();
            progressBarMask.beginFill(0xff0000);
            progressBarMask.drawRect(0, 0, progressBarBg.width, progressBarBg.height);
            progressBarMask.endFill();
            progressBarContainer.mask = progressBarMask;
            progressBarContainer.addChild(progressBarMask);

            progressBarMask.width = (
                0
            );
        });
    }

    onComponentAttached(_componentId: string, _component: Component): void {
    }

    onDetach(): void {
    }

    onDestroy() {
        super.onDestroy();
        this._texture.destroy(true);
        this._nineSlice.destroy();
    }
}